<script lang="ts">
  import { PreviewSupportedFileType } from '$shared/constants/PreviewSupportedFileType';
  import UIDisclaimer from '$provider/constants/UIDisclaimer';
  import { FilePreview as FilePreviewModel } from '$provider/models/filePreview/FilePreview';
  import InfoView from '$shared/organisms/InfoView/InfoView.svelte';
  import CsvViewer from './partials/CsvViewer.svelte';
  import ImageViewer from './partials/ImageViewer.svelte';
  import PdfViewer from './partials/PdfViewer.svelte';

  const MapPreviewComponent: Record<string, any> = {
    [PreviewSupportedFileType.Pdf]: PdfViewer,
    [PreviewSupportedFileType.Image]: ImageViewer,
    [PreviewSupportedFileType.Csv]: CsvViewer
  };

  interface Props {
    option: FilePreviewModel<unknown>;
  }

  let { option }: Props = $props();

  let activeComp = $derived(MapPreviewComponent[option?.type]);
</script>

{#if activeComp}
  {@const SvelteComponent = activeComp}
  <SvelteComponent data={option} />
{:else}
  <div class="info-disclaimer">
    <InfoView label={UIDisclaimer.ComponentRenderFailed} />
  </div>
{/if}
